// extracted by mini-css-extract-plugin
export default {"cloud":"Cloud_cloud__tIzQt","float":"Cloud_float__u2uu7"};